/**
 * Coups de pouce — attendu 624 (lire l’abscisse / graduer un segment).
 *
 * Routage par generator_key. Exemple HORS pool : les quarts (b = 4
 * absent du tirage guide-âne {3,5,6,7,9,10} — la leçon privilégie le
 * pliage pour 4, mais dit « je peux AUSSI plier » : le guide-âne reste
 * valide, et 5 lignes tiennent dans la vignette).
 */

// La méthode du guide-âne animée en 4 temps sur une seule scène :
// bande posée ligne 0 → elle PIVOTE (même longueur, l’inclinaison
// s’adapte — l’insight anti « ça dépend de la longueur ») → marques
// aux croisements → report sur le segment.
const SVG_GUIDE_ANE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 160" width="290" height="155" role="img" data-etapes="4"
     aria-label="La méthode du guide-âne pour partager un segment en 4. Je reporte la longueur du segment sur une bande de papier, posée sur la ligne 0. J’incline la bande, sans changer sa longueur, jusqu’à ce que son autre extrémité atteigne la ligne 4. Les lignes 1, 2 et 3 coupent la bande en 4 parts égales : je marque les croisements. Je reporte les marques sur le segment : il est gradué en quarts">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="4"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp624gan 8s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp624ganc 8s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp624gan 8s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp624ganc 8s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp624gan 8s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp624ganc 8s linear infinite 4s; }
      .d4 { opacity: 0; animation: cp624gan 8s linear infinite 6s; }
      .c4 { opacity: 0; animation: cp624gancf 8s linear infinite 6s; }
    }
    @keyframes cp624gan { 0%, 2% { opacity: 0; } 6%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp624ganc { 0%, 2% { opacity: 0; } 5%, 22% { opacity: 1; } 26%, 100% { opacity: 0; } }
    @keyframes cp624gancf { 0%, 2% { opacity: 0; } 5%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <line x1="30" y1="30.0" x2="290" y2="30.0" stroke="#94a3b8" stroke-width="1" opacity="0.5"/>
  <text x="18" y="33.5" text-anchor="middle" font-size="10" fill="#334155">0</text>
  <line x1="30" y1="52.0" x2="290" y2="52.0" stroke="#94a3b8" stroke-width="1" opacity="0.5"/>
  <text x="18" y="55.5" text-anchor="middle" font-size="10" fill="#334155">1</text>
  <line x1="30" y1="74.0" x2="290" y2="74.0" stroke="#94a3b8" stroke-width="1" opacity="0.5"/>
  <text x="18" y="77.5" text-anchor="middle" font-size="10" fill="#334155">2</text>
  <line x1="30" y1="96.0" x2="290" y2="96.0" stroke="#94a3b8" stroke-width="1" opacity="0.5"/>
  <text x="18" y="99.5" text-anchor="middle" font-size="10" fill="#334155">3</text>
  <line x1="30" y1="118.0" x2="290" y2="118.0" stroke="#94a3b8" stroke-width="1" opacity="0.5"/>
  <text x="18" y="121.5" text-anchor="middle" font-size="10" fill="#334155">4</text>
  <g class="anim d1" data-etape="1">
    <line x1="60.0" y1="30.0" x2="210.0" y2="30.0" stroke="#ec4899" stroke-width="10" stroke-linecap="round" opacity="0.35"/>
    <circle cx="60.0" cy="30.0" r="3" fill="#be185d"/>
    <circle cx="210.0" cy="30.0" r="3" fill="#be185d"/>
  </g>
  <g class="anim d2" data-etape="2">
    <path d="M 210.0 30.0 A 150.0 150.0 0 0 1 181.5 118.0" fill="none" stroke="#334155" stroke-width="1.2" stroke-dasharray="4 3"/>
    <polygon points="181.5,118.0 186.0,110.0 177.0,111.0" fill="#334155"/>
    <line x1="60.0" y1="30.0" x2="181.5" y2="118.0" stroke="#ec4899" stroke-width="10" stroke-linecap="round" opacity="0.45"/>
    <line x1="60.0" y1="30.0" x2="181.5" y2="118.0" stroke="#be185d" stroke-width="1.3"/>
  </g>
  <g class="anim d3" data-etape="3">
    <circle cx="90.4" cy="52.0" r="3.4" fill="#be185d"/>
    <circle cx="120.7" cy="74.0" r="3.4" fill="#be185d"/>
    <circle cx="151.1" cy="96.0" r="3.4" fill="#be185d"/>
  </g>
  <g class="anim d4" data-etape="4">
    <line x1="60.0" y1="12" x2="210.0" y2="12" stroke="#334155" stroke-width="2"/>
    <text x="52.0" y="9" text-anchor="middle" font-size="9" font-weight="bold" fill="#334155">A</text>
    <text x="218.0" y="9" text-anchor="middle" font-size="9" font-weight="bold" fill="#334155">B</text>
    <line x1="97.5" y1="7" x2="97.5" y2="17" stroke="#be185d" stroke-width="2"/>
    <line x1="135.0" y1="7" x2="135.0" y2="17" stroke="#be185d" stroke-width="2"/>
    <line x1="172.5" y1="7" x2="172.5" y2="17" stroke="#be185d" stroke-width="2"/>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="150" y="150" text-anchor="middle" font-size="11.5" fill="#334155">je reporte la longueur du segment sur <tspan font-weight="bold" fill="#be185d">une bande</tspan></text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="150" y="150" text-anchor="middle" font-size="11.5" fill="#334155">j’<tspan font-weight="bold">incline</tspan> la bande (même longueur !) jusqu’à la <tspan font-weight="bold">ligne 4</tspan></text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="150" text-anchor="middle" font-size="11.5" fill="#334155">les lignes 1, 2, 3 coupent la bande en <tspan font-weight="bold" fill="#be185d">4 parts égales</tspan></text>
  </g>
  <g class="anim c4" data-caption="4">
    <text x="150" y="150" text-anchor="middle" font-size="11.5" fill="#334155">je reporte les marques : [AB] est <tspan font-weight="bold" fill="#be185d">gradué en quarts</tspan> !</text>
  </g>
</svg>`.trim();

const FICHE_GUIDE_ANE = {
    pages: [
        {
            titre: 'La méthode du guide-âne',
            lignes: [
                'On cherche à **partager un segment en 4 parts égales** avec un guide-âne.',
                'La méthode marche pour **n\'importe quelle longueur** de segment : c\'est l\'**inclinaison** de la bande qui s\'adapte.',
                'Pour **4 parts**, vise la **ligne 4** : les lignes 1, 2, 3 marquent les coupes.',
            ],
            svg: SVG_GUIDE_ANE,
        },
    ],
};

// Lire une abscisse, animé 4 temps, en douzièmes (b = 12 hors de
// TOUS les pools de 624). La droite DÉPASSE 1 et A est à 15/12
// (retour user) : on voit que c’est l’UNITÉ qu’on découpe, et que
// numérateur > dénominateur ⇔ point au-delà de 1.
const SVG_LIRE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 155" width="290" height="150" role="img" data-etapes="4"
     aria-label="Demi-droite graduée qui dépasse 1, avec un point A situé après le 1. De 0 à 1 il y a 12 parts égales : des douzièmes, c’est l’unité qu’on découpe. Chaque graduation vaut un douzième. On compte 15 graduations depuis 0 jusqu’au point A. L’abscisse de A est 15 douzièmes : plus grand que 1">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="4"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp624lir 8s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp624lirc 8s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp624lir 8s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp624lirc 8s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp624lir 8s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp624lirc 8s linear infinite 4s; }
      .d4 { opacity: 0; animation: cp624lir 8s linear infinite 6s; }
      .c4 { opacity: 0; animation: cp624lircf 8s linear infinite 6s; }
    }
    @keyframes cp624lir { 0%, 2% { opacity: 0; } 6%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp624lirc { 0%, 2% { opacity: 0; } 5%, 22% { opacity: 1; } 26%, 100% { opacity: 0; } }
    @keyframes cp624lircf { 0%, 2% { opacity: 0; } 5%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <line x1="10" y1="70" x2="292" y2="70" stroke="#475569" stroke-width="1.5"/>
  <polygon points="298,70 290,66 290,74" fill="#475569"/>
  <line x1="16.0" y1="62.0" x2="16.0" y2="78.0" stroke="#475569" stroke-width="1.5"/>
  <line x1="30.9" y1="65.0" x2="30.9" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="45.8" y1="65.0" x2="45.8" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="60.7" y1="65.0" x2="60.7" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="75.6" y1="65.0" x2="75.6" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="90.4" y1="65.0" x2="90.4" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="105.3" y1="65.0" x2="105.3" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="120.2" y1="65.0" x2="120.2" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="135.1" y1="65.0" x2="135.1" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="150.0" y1="65.0" x2="150.0" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="164.9" y1="65.0" x2="164.9" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="179.8" y1="65.0" x2="179.8" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="194.7" y1="62.0" x2="194.7" y2="78.0" stroke="#475569" stroke-width="1.5"/>
  <line x1="209.6" y1="65.0" x2="209.6" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="224.4" y1="65.0" x2="224.4" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="239.3" y1="65.0" x2="239.3" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="254.2" y1="65.0" x2="254.2" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="269.1" y1="65.0" x2="269.1" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="284.0" y1="65.0" x2="284.0" y2="75.0" stroke="#475569" stroke-width="1"/>
  <text x="16.0" y="97" text-anchor="middle" font-size="11" fill="#475569">0</text>
  <text x="194.7" y="97" text-anchor="middle" font-size="11" fill="#475569">1</text>
  <circle cx="239.3" cy="70" r="3.4" fill="#f97316"/>
  <text x="239.3" y="97" text-anchor="middle" font-size="11" font-weight="bold" fill="#f97316">A</text>
  <g class="anim d1" data-etape="1">
    <rect x="16.0" y="58" width="178.7" height="24" fill="#fed7aa" fill-opacity="0.5"/>
  </g>
  <g class="anim d2" data-etape="2">
    <text x="30.9" y="40.0" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">1</text><line x1="22.4" y1="43.5" x2="39.4" y2="43.5" stroke="#b45309" stroke-width="1.1"/><text x="30.9" y="52.5" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">12</text>
    <line x1="30.9" y1="56" x2="30.9" y2="60" stroke="#b45309" stroke-width="1"/>
  </g>
  <g class="anim d3" data-etape="3">
    <circle cx="30.9" cy="70" r="2.2" fill="#f97316"/>
    <circle cx="45.8" cy="70" r="2.2" fill="#f97316"/>
    <circle cx="60.7" cy="70" r="2.2" fill="#f97316"/>
    <circle cx="75.6" cy="70" r="2.2" fill="#f97316"/>
    <circle cx="90.4" cy="70" r="2.2" fill="#f97316"/>
    <circle cx="105.3" cy="70" r="2.2" fill="#f97316"/>
    <circle cx="120.2" cy="70" r="2.2" fill="#f97316"/>
    <circle cx="135.1" cy="70" r="2.2" fill="#f97316"/>
    <circle cx="150.0" cy="70" r="2.2" fill="#f97316"/>
    <circle cx="164.9" cy="70" r="2.2" fill="#f97316"/>
    <circle cx="179.8" cy="70" r="2.2" fill="#f97316"/>
    <circle cx="194.7" cy="70" r="2.2" fill="#f97316"/>
    <circle cx="209.6" cy="70" r="2.2" fill="#f97316"/>
    <circle cx="224.4" cy="70" r="2.2" fill="#f97316"/>
    <circle cx="239.3" cy="70" r="2.2" fill="#f97316"/>
  </g>
  <g class="anim d4" data-etape="4">
    <circle cx="239.3" cy="70" r="5" fill="none" stroke="#f97316" stroke-width="2.5"/>
    <text x="239.3" y="40.0" text-anchor="middle" font-size="10.5" font-weight="bold" fill="#f97316">15</text><line x1="230.8" y1="43.5" x2="247.8" y2="43.5" stroke="#f97316" stroke-width="1.1"/><text x="239.3" y="52.5" text-anchor="middle" font-size="10.5" font-weight="bold" fill="#f97316">12</text>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="150" y="142" text-anchor="middle" font-size="11.5" fill="#334155">on découpe <tspan font-weight="bold">l’unité</tspan> : de 0 à 1, <tspan font-weight="bold" fill="#b45309">12 parts</tspan></text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="150" y="142" text-anchor="end" font-size="11.5" fill="#334155">chaque graduation vaut</text>
    <text x="166.0" y="134.0" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">1</text><line x1="157.5" y1="137.5" x2="174.5" y2="137.5" stroke="#b45309" stroke-width="1.1"/><text x="166.0" y="146.5" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">12</text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="142" text-anchor="middle" font-size="11.5" fill="#334155">compte <tspan font-weight="bold" fill="#f97316">15 graduations</tspan> depuis 0 jusqu’à A</text>
  </g>
  <g class="anim c4" data-caption="4">
    <text x="116" y="142" text-anchor="end" font-size="11.5" fill="#334155">l’abscisse de A est</text>
    <text x="132.0" y="134.0" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">15</text><line x1="123.5" y1="137.5" x2="140.5" y2="137.5" stroke="#f97316" stroke-width="1.1"/><text x="132.0" y="146.5" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">12</text>
    <text x="146" y="142" font-size="11.5" fill="#334155">: plus grand que 1 !</text>
  </g>
</svg>`.trim();

const FICHE_LIRE = {
    pages: [
        {
            titre: 'Lire l\'abscisse d\'un point',
            lignes: [
                'Le **dénominateur** : compte en combien de **parts égales** une unité est coupée.',
                'Le **numérateur** : compte les graduations depuis **0** jusqu\'au point.',
            ],
            svg: SVG_LIRE,
        },
    ],
};

// La valeur du pas, sobre : l'erreur canonique est de compter les
// TRAITS au lieu des intervalles (les distracteurs 1/(b−1) et 1/(b+1)
// du QCM la matérialisent). Onzièmes : b = 11 hors du pool {2..10, 12}.
const FICHE_PAS = {
    pages: [
        {
            titre: 'Que vaut une graduation ?',
            lignes: [
                'Repère **deux entiers voisins** sur la demi-droite (par exemple 2 et 3).',
                'Compte les **intervalles** entre eux : s\'il y en a 11, chaque graduation vaut $\\dfrac{1}{11}$.',
            ],
        },
    ],
};

// La fraction d'un segment, sobre : partie sur tout. L = 13 hors pool
// (le tirage s'arrête à 12).
const FICHE_SEGMENT = {
    pages: [
        {
            titre: 'La partie sur le tout',
            lignes: [
                'La fraction, c\'est **la partie sur le tout** : la longueur de AC **au numérateur**, la longueur totale AB **au dénominateur**.',
                'Exemple : si AC = 5 cm et AB = 13 cm, alors AC représente $\\dfrac{5}{13}$ de AB.',
                'Vérifie sur le schéma : les flèches montrent **qui mesure quoi**.',
            ],
        },
    ],
};

// completer_graduation_saisie : PAS de fiche (arbitrage utilisateur
// 2026-08-02 — l'exercice se suffit, les graduations visibles guident).

const CP_624 = {
    lire_abscisse_qcm: FICHE_LIRE,
    lire_abscisse_trou_saisie: FICHE_LIRE,
    lire_abscisse_vf: FICHE_LIRE,
    lire_abscisse_relier: FICHE_LIRE,
    lire_methode_drag: FICHE_LIRE,
    lire_pas_qcm: FICHE_PAS,
    fraction_segment_saisie: FICHE_SEGMENT,
    graduer_segment_ordonner: FICHE_GUIDE_ANE,
    graduer_segment_qcm: FICHE_GUIDE_ANE,
};

export default CP_624;
